import React from "react";
import { Icon, Modal } from "antd";

import InitialsAvatar from "../../../shared/components/InitialsAvatar";

const ModalListaParticipantes = ({ loading, participantes, visible, setVisible }) => {
    return (
        <Modal
            title={
                <>
                    Participantes
                    <br />
                    <span style={{ fontSize: 13, color: "#8e9aa0" }}>Total: {participantes.length}</span>
                </>
            }
            visible={visible}
            onCancel={setVisible}
            maskClosable={false}
            className="modal-lista-participantes"
            footer={null}
        >
            <div className="bloco-lista-participantes">
                {loading ? (
                    <div className="bloco-loading">
                        <p>
                            <Icon className="icon-loading" type="loading" />
                        </p>
                        <p className="texto">A carregar...</p>
                    </div>
                ) : (
                    participantes.map((participante, index) => (
                        <div key={index} className="info-participante">
                            <div className="bloco-img">
                                {participante.foto ? <img src={participante.foto} /> : <InitialsAvatar name={participante.nome} />}
                            </div>
                            <div className="info">
                                <span className="nome">{participante.nome}</span>
                                <p className="numero">{participante.numero}</p>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </Modal>
    );
};

export default ModalListaParticipantes;
